/**
 * Verifica y retorna el mensaje correspondiente.
 * @param {string} param - El parámetro a verificar generado por e-auth-n.
 * @param {string} appCode - Código de aplicación.
 * @returns {Object} - El mensaje correspondiente al parámetro o un valor predeterminado.
 * @property {string} title - El título del mensaje.
 * @property {string} subtitle - El subtítulo del mensaje.
 */
export const checkParamErrorEAuth = (param, appCode) => {
  const appName = getNameByAppCode(appCode);

  /**
   * Objeto que contiene los textos correspondientes a cada parámetro.
   * @type {Object.<string, { title: string, subtitle: string }>}
   */
  const texts = {
    // Case 1
    applicationInstanceId: {
      title: `Lo sentimos, no tenés acceso \na ${appName}`,
      subtitle: `<span>Para acceder comunicate con un representante comercial o \ningresá <a href='https://www.errepar.com/mi-estudio'>aquí</a>.</span>`
    },
    // Case 2
    orgAppAccessStatusCode: {
      title: `¡Lo sentimos!`,
      subtitle: `<span>No podemos mostrarte ${appName}, por favor comunicate \ncon nuestro Centro de Atención al Cliente al (011) 4370-2002 o\n a <a href="mailto:miestudio@errepar.com">miestudio@errepar.com</a> para que te habilitemos la aplicación.</span>`
    },
    // Case 3
    userAppAccessStatusCode: {
      title: `Lo sentimos, no tenés acceso \na ${appName}`,
      subtitle: `Para tener acceso, comunicate con el administrador del Estudio.`
    },
    // Case 4
    appRoles: {
      title: `¡Lo sentimos!`,
      subtitle: `<span>No podemos mostrarte ${appName}, por favor comunicate\n con nuestro Centro de Atención al Cliente al (011) 4370-2002 o\n a <a href="mailto:miestudio@errepar.com">miestudio@errepar.com</a> para que te asignen un rol en la aplicación.</span>`
    },
    // Case 5
    legacySubscriberRefId: {
      title: `¡Lo sentimos!`,
      subtitle: `<span>No podemos mostrarte Mi Estudio, por favor comunicate con nuestro \nCentro de Atención al Cliente al (011) 4370-2002 o por mail a\n <a href="mailto:miestudio@errepar.com">miestudio@errepar.com</a> indicando el código de referencia: Suscriptor.Ref.</span>`
    },
    // Case 6
    legacyUserRefId: {
      title: `¡Lo sentimos!`,
      subtitle: `<span>No podemos mostrarte Mi Estudio, por favor comunicate con nuestro \nCentro de Atención al Cliente al (011) 4370-2002 o por mail a \n<a href="mailto:miestudio@errepar.com">miestudio@errepar.com</a> indicando el código de referencia: Usuario.Ref.</span>`
    },
  };

  /**
   * Valor predeterminado en caso de que el parámetro no coincida con ninguno de los casos.
   * @type {{ title: string, subtitle: string }}
   */
  const defaultValue = {
    title: '¡Lo sentimos!',
    subtitle: 'Tu mail no está correctamente asociado. Por favor, contactanos para que podamos resolverlo al 11 4370-2002 o por chat.'
  };

  // Devuelve el texto correspondiente al parámetro o el valor predeterminado.
  return texts[param] ?? defaultValue;
};


/**
 * Obtiene el nombre de una aplicación en función de su código.
 * @param {string} appCode - El código de la aplicación.
 * @returns {string} El nombre de la aplicación correspondiente al código proporcionado, o "Errepar" si no se encuentra.
 */
const getNameByAppCode = (appCode) => {

  const applicationNames = {
    CGI: "Consola de Gestión Interna",
    ME: "Mi Estudio"
  };
  const code = String(appCode).toUpperCase();

  // Devuelve el nombre de la aplicación correspondiente al código, o "Errepar" si no se encuentra.
  return applicationNames[code] || "Errepar";
};
